// extracted by mini-css-extract-plugin
export default {"container":"style_container__kH1jD","logoSection":"style_logoSection__xshMO","title":"style_title__P12FE","subName":"style_subName__dDKLK"};